import useCheckoutPricing from '../useCheckoutPricing';

export default function useBonus() {
  const {
    maxBonuses,
    maxCashbackCanUse,
    isInvisible,
    isUsingBonuses,
    isDisabled,
    canApplyBonuses,
    sailplayDiscount,
    bonusesRest,
    maxBonusesMinusGifts,
    giftsForBonusesSum,
    eligibleForBonusesTotal,
  } = useCheckoutPricing();

  return {
    maxBonuses,
    isInvisible,
    maxCashbackCanUse,
    isDisabled,
    isUsingBonuses,
    canApplyBonuses,
    sailplayDiscount,
    bonusesRest,
    maxBonusesMinusGifts,
    giftsForBonusesSum,
    eligibleForBonusesTotal,
  };
}
